/**
 * KeycloakProvider.js
 * desc: provider component used for user authentication with keycloak service
 * note: responsible for initializing keycloak service and creating ReactKeycloakProvider wrapper component
 */

import { useEffect, useRef } from 'react';
import Keycloak from 'keycloak-js';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { isRefreshTokenExpired, logoutDueToInactivity, setKeycloak } from '../../utilities/authentication';
import { setItem } from '../../utilities/local-storage';

const keycloak = new Keycloak(window.Ym && window.Ym.KEYCLOAK_CONFIG ? window.Ym.KEYCLOAK_CONFIG : {});
setKeycloak(keycloak);

const keycloakProviderInitConfig = {
    onLoad: 'login-required',
    checkLoginIframe: false
};

const KeycloakProvider = ( { children } ) => {
    const intervalRef = useRef(); 
    const ONE_MINUTE = 60 * 1000;

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            if (isRefreshTokenExpired()) {
                logoutDueToInactivity();
            }
        }, ONE_MINUTE);
        return () => clearInterval(intervalRef.current);
    }, []);

    const onTokensUpdate = () => {
        // save refresh token expiration time to local storage so we can share it across multiple opened tabs
        if (keycloak && keycloak.refreshTokenParsed) {
            setItem('refreshTokenExp', keycloak.refreshTokenParsed.exp);
        }
    };

    return <ReactKeycloakProvider
        authClient={ keycloak }
        initOptions={ keycloakProviderInitConfig }
        autoRefreshToken={ false }
        onTokens={ onTokensUpdate }
    >
        <>{ children }</>
    </ReactKeycloakProvider>;
};


export default KeycloakProvider;
